import { PlatformSlug } from 'constants/consts'
import { validateRequired, validateRequiredHtml } from 'utils/validation'
import { PlatformProductConfig } from 'pagesNew/Products/consts'
import { isCrashCoursesAvailable } from 'pagesNew/CrashCourses/platformConfig'

export enum EmailsTabs {
  FreeMembershipActivation = 'Free Membership Activation',
  PaidMembershipActivation = 'Paid Membership Activation',
  CrashCoursePurchased = 'Crash Course Purchased',
  MembershipExpiration = 'Membership Expiration',
  PaidMembershipActivationOrSubscriptionStarted = 'Paid Membership Activation / Subscription Started',
  SubscriptionStarted = 'Subscription Started',
  SubscriptionCanceled = 'Subscription Canceled',
  SubscriptionPaymentFailed = 'Failed Payment',
  PauseUnpauseMembership = 'Membership Pause/Unpause',
  PasswordReset = 'Password Reset',
}

type EmailsConfigInput = Pick<PlatformProductConfig, 'regularMemberships' | 'subscriptionMemberships' | 'pauseTokens'>

export const getEmailsTabsByConfig = (config: EmailsConfigInput, platformSlug?: PlatformSlug): EmailsTabs[] => {
  const tabs: EmailsTabs[] = [EmailsTabs.FreeMembershipActivation]

  if (config.regularMemberships && config.subscriptionMemberships) {
    // Hybrid memberships emails
    tabs.push(
      EmailsTabs.PaidMembershipActivationOrSubscriptionStarted,
      EmailsTabs.MembershipExpiration,
      EmailsTabs.SubscriptionCanceled,
      EmailsTabs.SubscriptionPaymentFailed
    )
  } else if (config.regularMemberships) {
    // Regular membership emails
    tabs.push(EmailsTabs.PaidMembershipActivation)

    if (isCrashCoursesAvailable(platformSlug)) {
      tabs.push(EmailsTabs.CrashCoursePurchased)
    }

    tabs.push(EmailsTabs.MembershipExpiration)
  } else if (config.subscriptionMemberships) {
    // Subscription membership emails
    tabs.push(EmailsTabs.SubscriptionStarted, EmailsTabs.SubscriptionCanceled, EmailsTabs.SubscriptionPaymentFailed)
  }

  if (config.pauseTokens) {
    tabs.push(EmailsTabs.PauseUnpauseMembership)
  }

  tabs.push(EmailsTabs.PasswordReset)

  return tabs
}

export const validateEmailSubject = (value = '') => {
  const requiredValidation = validateRequired(value)
  if (requiredValidation) {
    return requiredValidation
  }
  return value.length > 100 ? 'Must be less than 100 characters' : undefined
}

export const validatePasswordResetEmail = (value = '') => {
  const requiredValidation = validateRequiredHtml(value)
  if (requiredValidation) {
    return requiredValidation
  }

  const doc = new DOMParser().parseFromString(value, 'text/html')
  const links = Array.from(doc.querySelectorAll('a'))
  const link = links.find(
    (link) => link.textContent?.toLowerCase() === 'click here' && link.getAttribute('href') === ''
  )
  return !link ? 'Template must include an empty link with "Click here" text' : undefined
}
